var _defs, _rect, _polygon, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagBrazil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#009b3a;}.c{fill:#fedf00;}.d{fill:#fdfeff;}.e{fill:#002776;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 20,
    y: -20,
    width: 60,
    height: 100,
    transform: "translate(20 80) rotate(-90)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "85.89 30 50 52.86 14.11 30 50 7.14 85.89 30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M40.77,25.74c9.06,0,17.35,3.25,23.78,8.65-1.89,6.25-7.69,10.8-14.55,10.8-8.39,0-15.19-6.8-15.19-15.19,0-1.33,.17-2.62,.5-3.85,1.78-.27,3.61-.41,5.46-.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M65.19,30c0,.74-.05,1.47-.16,2.19-6.47-5.53-14.87-8.87-24.06-8.87-1.61,0-3.2,.1-4.76,.31,2.4-5.21,7.67-8.82,13.79-8.82,8.39,0,15.19,6.8,15.19,15.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M65.03,32.19c-.1,.75-.27,1.49-.48,2.2-6.43-5.4-14.72-8.65-23.78-8.65-1.85,0-3.68,.14-5.46,.41,.22-.87,.52-1.72,.9-2.52,1.56-.21,3.15-.31,4.76-.31,9.19,0,17.59,3.34,24.06,8.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrazil);
export default __webpack_public_path__ + "static/media/FlagBrazil.5f524e6c1382d8883734902035b60f3b.svg";
export { ForwardRef as ReactComponent };